module.exports = __webpack_public_path__ + "img/首页-ras@2x.ba5e4f38.png";